import { usePlatformSettings } from "@/hooks/usePlatformSettings";
import { Badge } from "@/components/ui/badge";
import { useSubscription } from "@/hooks/useSubscription";
import { TIER_LABELS } from "@/lib/tiers";
import { Sparkles } from "lucide-react";

export function TierBadge({ className }: { className?: string }) {
  const { tier, isGrandfathered, loading } = useSubscription();
  const { pricingEnabled } = usePlatformSettings();
  if (loading || !pricingEnabled) return null;

  const variant = tier === "organization" ? "default" : tier === "team" ? "secondary" : "outline";
  return (
    <Badge variant={variant} className={className}>
      {tier === "organization" && <Sparkles className="w-3 h-3 mr-1" />}
      {TIER_LABELS[tier]}
      {isGrandfathered && tier !== "personal" && " · Free"}
    </Badge>
  );
}
